import { render, staticRenderFns } from "./StudioLessonCard.vue?vue&type=template&id=1fba8ab0&scoped=true&"
import script from "./StudioLessonCard.vue?vue&type=script&lang=js&"
export * from "./StudioLessonCard.vue?vue&type=script&lang=js&"
import style0 from "./StudioLessonCard.vue?vue&type=style&index=0&id=1fba8ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba8ab0",
  null
  
)

export default component.exports